<div #detailInfo class="detail-info py-5" style="scroll-margin-top: 192px">
    <div class="container">
        <p class="title text-center">INFORMATIONS DU PRODUIT</p>
        <div class="wrap-tab-info">
            <p-tabView [scrollable]="true">
                <p-tabPanel header="CARACTÉRISTIQUES PRODUITS">
                    <div class="wrap-tab wrap-tab-1">
                        <div
                            *ngIf="listImageSustainableDevelopments.length > 0"
                            class="group-logo d-flex gap-2 mb-2 flex-wrap"
                        >
                            <ng-container
                                *ngFor="let imgSusDev of listImageSustainableDevelopments"
                            >
                                <div
                                    *ngIf="displayImgSusDev(imgSusDev, item?.[imgSusDev.field])"
                                    class="wrap-logo text-center"
                                >
                                    <img
                                        class="mb-0"
                                        style="width: 80px; height: 80px; object-fit: contain"
                                        [src]="imgSusDev?.urlImage"
                                        width="80"
                                        alt=""
                                        [title]="imgSusDev?.label ?? ''"
                                    />
                                    <!-- <p class="font-bold mb-0">{{imgSusDev?.label}}</p> -->
                                </div>
                            </ng-container>
                        </div>
                        <div class="wrap-content list">
                            <p *ngFor="let item of dataDetailProperties" class="wrap-text one-list">
                                <ng-template
                                    [ngTemplateOutlet]="detailItemTmpl"
                                    [ngTemplateOutletContext]="{ item: item }"
                                ></ng-template>
                            </p>
                            <span class="wrap-text two-list">
                                <p
                                    *ngFor="let item of dataDetailPropertiesBySide.left"
                                    style="width: 100%"
                                >
                                    <ng-template
                                        [ngTemplateOutlet]="detailItemTmpl"
                                        [ngTemplateOutletContext]="{ item: item }"
                                    ></ng-template>
                                </p>
                            </span>
                            <span class="wrap-text two-list">
                                <p
                                    *ngFor="let item of dataDetailPropertiesBySide.right"
                                    style="width: 100%"
                                >
                                    <ng-template
                                        [ngTemplateOutlet]="detailItemTmpl"
                                        [ngTemplateOutletContext]="{ item: item }"
                                    ></ng-template>
                                </p>
                            </span>
                        </div>
                    </div>
                </p-tabPanel>

                <p-tabPanel header="DOCUMENTS FT FDS">
                    <div class="wrap-tab wrap-tab-3">
                        <div
                            *ngIf="allResultParse?.dateOfFds || allResultParse?.versionRevision"
                            class="wrap-content"
                        >
                            <p *ngIf="allResultParse?.dateOfFds" class="wrap-text">
                                {{ allResultParse?.dateOfFds?.variableLabel }} :
                                <span>{{
                                    allResultParse?.dateOfFds?.value | date : 'dd/MM/yyyy'
                                }}</span>
                            </p>

                            <p *ngIf="allResultParse?.versionRevision" class="wrap-text">
                                {{ allResultParse?.versionRevision?.variableLabel }} :
                                <span>{{ allResultParse?.versionRevision?.value }}</span>
                            </p>
                        </div>

                        <div class="group-file d-flex flex-wrap">
                            <ng-container *ngFor="let item of listUrlImageProduct">
                                <div class="wrap-file p-2" *ngIf="!item?.imgURL">
                                    <a class="" (click)="openFile(item)" target="_blank">
                                        <img
                                            src="src-adisco/assets/images/icon/file-text.png"
                                            alt=""
                                        />
                                        <div class="wrap-text">
                                            <p class="mb-0 font-bold">{{ item?.nameFile }}</p>
                                            <p class="mb-0">{{ item?.nameFileDetail }}</p>
                                        </div>
                                    </a>
                                </div>
                                <div *ngIf="item?.imgURL" style="max-height: 63px">
                                    <img
                                        [src]="item.imgURL"
                                        style="width: 100%; height: 100%; object-fit: cover"
                                    />
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </p-tabPanel>

                <p-tabPanel header="CONDITIONNEMENT D'ACHAT">
                    <div class="wrap-tab wrap-tab-2">
                        <div class="wrap-content d-flex">
                            <div class="wrap-text">
                                <p *ngIf="item?.primaryPackagingANumber">
                                    Quantité primaire :
                                    <span>{{
                                        item?.primaryPackagingANumber
                                            ? item?.primaryPackagingANumber
                                            : '-'
                                    }}</span>
                                </p>
                                <p *ngIf="item?.primaryPackagingAUnitOfMeasurement">
                                    Conditionnement primaire :
                                    <span>{{
                                        item?.primaryPackagingAUnitOfMeasurement?.labels
                                            ? item?.primaryPackagingAUnitOfMeasurement?.labels
                                                  ?.fr_FR
                                            : '-'
                                    }}</span>
                                </p>
                                <p *ngIf="item?.numberOfProductsPerPrimaryPackaging">
                                    Quantité de produits / conditionnement primaire :
                                    <span>{{
                                        item?.numberOfProductsPerPrimaryPackaging
                                            ? item?.numberOfProductsPerPrimaryPackaging
                                            : '-'
                                    }}</span>
                                </p>
                                <p *ngIf="item?.primaryPackagingDesignation" class="mb-5">
                                    Unité de mesure du produit :
                                    <span>{{
                                        item?.primaryPackagingDesignation
                                            ? item?.primaryPackagingDesignation
                                            : '-'
                                    }}</span>
                                </p>
                                <p *ngIf="item?.unitWeightPrimary">
                                    Poids unitaire Primaire :
                                    <span>{{
                                        item?.unitWeightPrimary ? item?.unitWeightPrimary : '-'
                                    }}</span>
                                </p>
                                <p *ngIf="item?.gencodeProduct" class="mb-5">
                                    Code EAN Produit :
                                    <span>{{
                                        item?.gencodeProduct ? item?.gencodeProduct : '-'
                                    }}</span>
                                </p>
                                <p *ngIf="item?.secondaryPackagingDesignation">
                                    Conditionnement secondaire :
                                    <span>{{
                                        item?.secondaryPackagingDesignation
                                            ? item?.secondaryPackagingDesignation
                                            : '-'
                                    }}</span>
                                </p>
                                <p *ngIf="item?.totalWeightSecondary">
                                    Poids total Secondaire :
                                    <span>{{
                                        item?.totalWeightSecondary
                                            ? item?.totalWeightSecondary
                                            : '-'
                                    }}</span>
                                </p>
                                <p *ngIf="item?.gencodeCarton">
                                    Code EAN Carton :
                                    <span>{{
                                        item?.gencodeCarton ? item?.gencodeCarton : '-'
                                    }}</span>
                                </p>
                            </div>
                            <div class="wrap-text">
                                <p *ngIf="item?.tertiaryPackagingDesignation">
                                    Conditionnement tertiaire :
                                    <span>{{
                                        item?.tertiaryPackagingDesignation
                                            ? item?.tertiaryPackagingDesignation
                                            : '-'
                                    }}</span>
                                </p>
                                <p
                                    *ngIf="item?.numberOfSecondaryPackagesPerTertiaryPackage"
                                    class="mb-5"
                                >
                                    Nombre de conditionnements secondaires / conditionnement
                                    tertiaire :
                                    <span>{{
                                        item?.numberOfSecondaryPackagesPerTertiaryPackage
                                            ? item?.numberOfSecondaryPackagesPerTertiaryPackage
                                            : '-'
                                    }}</span>
                                </p>
                                <p *ngIf="item?.palletWidth">
                                    Largeur (en mètre) de la palette :
                                    <span>{{ item?.palletWidth ? item?.palletWidth : '-' }}</span>
                                </p>
                                <p *ngIf="item?.palletLength">
                                    Longueur (en mètre) de la palette :
                                    <span>{{ item?.palletLength ? item?.palletLength : '-' }}</span>
                                </p>
                                <p *ngIf="item?.palletHeight">
                                    Hauteur de la palette :
                                    <span>{{ item?.palletHeight ? item?.palletHeight : '-' }}</span>
                                </p>
                                <p *ngIf="item?.palletWeight">
                                    Poids de la palette :
                                    <span>{{ item?.palletWeight ? item?.palletWeight : '-' }}</span>
                                </p>
                                <p *ngIf="item?.numberOfPalletsPerTruck">
                                    Quantité de palette par camion :
                                    <span>{{
                                        item?.numberOfPalletsPerTruck
                                            ? item?.numberOfPalletsPerTruck
                                            : '-'
                                    }}</span>
                                </p>
                                <p *ngIf="item?.tgap">
                                    TGAP (Taxe générale sur les activités polluantes):
                                    <span>{{ item?.tgap ? item?.tgap : '-' }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>

                <p-tabPanel
                    *ngIf="userService.hasExtranetAccess('fonctions', 'catalogue-tarifs')"
                    header="TARIFICATION"
                >
                    <div class="wrap-tab wrap-tab-4">
                        <div class="wrap-table mb-4">
                            <p class="title-table font-bold mb-1">TARIFS ACTUELS</p>
                            <p-table [value]="priceCurrent">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th class="font-bold" style="min-width: 110px">
                                            Condition de prix
                                        </th>
                                        <th class="font-bold">
                                            Unité de condition d'achat minimum
                                        </th>
                                        <th class="font-bold" style="min-width: 135px">
                                            Condition du Tertiaire
                                        </th>
                                        <th
                                            class="font-bold"
                                            style="min-width: 80px; max-width: 80px"
                                        >
                                            Prix net au cdt de vente
                                        </th>
                                        <th class="font-bold">Niveau de prix (UA mini)</th>
                                        <th
                                            class="font-bold"
                                            style="max-width: 140px; min-width: 140px"
                                        >
                                            Qté d'unités primaires dans 1 secondaire
                                        </th>
                                        <th class="font-bold" style="min-width: 120px">
                                            Date début validité
                                        </th>
                                        <th class="font-bold" style="min-width: 100px">
                                            Date fin validité
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td class="font-bold">
                                            {{
                                                item.priceCondition
                                                    ? item.typeOftariff?.value === 'PAR_FRANCO'
                                                        ? item.priceCondition + ' €'
                                                        : item.priceCondition
                                                    : '-'
                                            }}
                                        </td>
                                        <td class="font-bold">
                                            {{
                                                item.minimumPurchaseConditionUnit?.labels?.fr_FR
                                                    ? item.minimumPurchaseConditionUnit?.labels
                                                          ?.fr_FR
                                                    : '-'
                                            }}
                                        </td>
                                        <td class="font-bold">
                                            {{
                                                item?.tertiaryCondition?.labels?.fr_FR
                                                    ? item?.tertiaryCondition?.labels?.fr_FR
                                                    : '-'
                                            }}
                                        </td>
                                        <td class="font-bold">{{ item?.price ?? '-' }}</td>
                                        <td class="font-bold">
                                            {{
                                                item.priceLevel?.labels?.fr_FR
                                                    ? item?.priceLevel?.labels?.fr_FR
                                                    : '-'
                                            }}
                                        </td>
                                        <td class="font-bold">
                                            {{ item.minimumQuantity ? item?.minimumQuantity : '-' }}
                                        </td>
                                        <td class="font-bold">
                                            {{ formatDate(item.applicationStartDate) }}
                                        </td>
                                        <td class="font-bold">
                                            {{ formatDate(item.applicationEndDate) }}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <div class="wrap-table">
                            <p class="title-table font-bold mb-1">TARIFS ANTÉRIEURS</p>
                            <p-table [value]="pricePrev">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th class="font-bold" style="min-width: 110px">
                                            Condition de prix
                                        </th>
                                        <th class="font-bold">
                                            Unité de condition d'achat minimum
                                        </th>
                                        <th class="font-bold" style="min-width: 135px">
                                            Condition du Tertiaire
                                        </th>
                                        <th
                                            class="font-bold"
                                            style="min-width: 80px; max-width: 80px"
                                        >
                                            Prix net au cdt de vente
                                        </th>
                                        <th class="font-bold">Niveau de prix (UA mini)</th>
                                        <th
                                            class="font-bold"
                                            style="max-width: 140px; min-width: 140px"
                                        >
                                            Qté d'unités primaires dans 1 secondaire
                                        </th>
                                        <th class="font-bold" style="min-width: 120px">
                                            Date début validité
                                        </th>
                                        <th class="font-bold" style="min-width: 100px">
                                            Date fin validité
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-item>
                                    <tr>
                                        <td class="font-bold">
                                            {{
                                                item.priceCondition
                                                    ? item.typeOftariff?.value === 'PAR_FRANCO'
                                                        ? item.priceCondition + ' €'
                                                        : item.priceCondition
                                                    : '-'
                                            }}
                                        </td>
                                        <td class="font-bold">
                                            {{
                                                item.minimumPurchaseConditionUnit?.labels?.fr_FR
                                                    ? item.minimumPurchaseConditionUnit?.labels
                                                          ?.fr_FR
                                                    : '-'
                                            }}
                                        </td>
                                        <td class="font-bold">
                                            {{
                                                item?.tertiaryCondition?.labels?.fr_FR
                                                    ? item?.tertiaryCondition?.labels?.fr_FR
                                                    : '-'
                                            }}
                                        </td>
                                        <td class="font-bold">
                                            {{ item.price ? item?.price : '-' }}
                                        </td>
                                        <td class="font-bold">
                                            {{
                                                item.priceLevel?.labels?.fr_FR
                                                    ? item?.priceLevel?.labels?.fr_FR
                                                    : '-'
                                            }}
                                        </td>
                                        <td class="font-bold">
                                            {{ item.minimumQuantity ? item?.minimumQuantity : '-' }}
                                        </td>
                                        <td class="font-bold">
                                            {{ formatDate(item.applicationStartDate) }}
                                        </td>
                                        <td class="font-bold">
                                            {{ formatDate(item.applicationEndDate) }}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </p-tabPanel>
            </p-tabView>
        </div>
    </div>
</div>
<p-dialog
    header="Fichier d'aperçu"
    [modal]="true"
    [(visible)]="visibleItem"
    [style]="{ width: '70%' }"
>
    <div class="popup-del-row">
        <div class="w-100 text-end">
            <a href="#" class="btn-common p-2" (click)="onDownload($event)">Télécharger</a>
        </div>
        <div id="outerContainer">
            <div class="pdf-container" [ngClass]="{ loaded: pdfLoaded }">
                <pdf-viewer
                    [src]="itemPdfShow?.urlFile || ''"
                    [rotation]="0"
                    [original-size]="false"
                    [show-all]="true"
                    [fit-to-page]="false"
                    [zoom]="1"
                    [zoom-scale]="'page-width'"
                    [stick-to-page]="false"
                    [render-text]="true"
                    [external-link-target]="'blank'"
                    [autoresize]="true"
                    [show-borders]="false"
                    style="max-width: 100; width: 100%; height: 100vh"
                    (page-rendered)="pageRendered($event)"
                    (after-load-complete)="pageProgress($event)"
                ></pdf-viewer>
            </div>
        </div>
    </div>
</p-dialog>

<ng-template #detailItemTmpl let-item="item">
    <ng-container *ngIf="item !== null">
        {{ item?.key }} :

        <span *ngIf="item?.type === 'BOOLEAN'">{{ item?.value ? 'Oui' : 'Non' }}</span>
        <ng-container *ngIf="item?.type === 'TEXT'">
            <span *ngIf="!isObjectValue(item?.value)">{{ item?.value ? item?.value : '-' }}</span>
            <span *ngIf="isObjectValue(item?.value)">
                {{ item?.value.fr_FR || '-' }}
            </span>
        </ng-container>

        <span *ngIf="item?.type === 'DATE_TIME'">{{ item?.value | date : 'dd/MM/yyyy' }}</span>
        <span *ngIf="item?.type === 'NUMBER'">{{ item?.value }}</span>
        <span *ngIf="item?.type === 'DOCUMENT_LINKS'">
            <span *ngFor="let subItem of item.value; let i = index">
                <ng-container *ngIf="i > 0">, </ng-container>{{ subItem.value }}
            </span>
        </span>
        <span *ngIf="item?.type === 'PARAMETER_LINK'">{{ item?.value.labels.fr_FR }}</span>
        <span *ngIf="item?.type === 'PARAMETER_LINKS'">
            <span *ngFor="let subItem of item.value; let i = index">
                <ng-container *ngIf="i > 0">, </ng-container>{{ subItem.labels?.fr_FR }}
            </span>
        </span>
    </ng-container>
</ng-template>
